<template>
    <v-dialog v-model="modelValue" :max-width="dialogWidth" :z-index="zIndex" class="dialog-window" @click:outside="$emit('close')">
        <v-card class="rounded-lg">
            <v-card-title class="px-6 pt-6 mb-4 d-flex align-center justify-space-between">
                <h3 class="font-weight-black flex-1-1-100 text-size-xl">{{ title }}</h3>
                <div class="dialog-window__close-button cursor-pointer" @click="$emit('close')">
                    <svg-icon class="d-block" :icon="icon" :alt="title" />
                </div>
            </v-card-title>
            <slot />
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { DEFAULT_Z_INDEX, DIALOG_WIDTH } from '@/features/Profile/constants';
import close from '@/assets/close.svg';
import SvgIcon from '@/features/common/components/SvgIcon.vue';

interface IDialog {
    title: string;
    icon?: string;
    dialogWidth?: number;
    zIndex?: number;
}

interface IDialogEmits {
    (e: 'close'): void;
}

defineEmits<IDialogEmits>();

const modelValue = defineModel<boolean>('modelValue');

withDefaults(defineProps<IDialog>(), {
    icon: close as string,
    dialogWidth: DIALOG_WIDTH,
    zIndex: DEFAULT_Z_INDEX
});
</script>
